export const ORDER_DATA='ORDER_DATA';
export const ORDER_DATA_REPAY='ORDER_DATA_REPAY';

//下面是新版
export const ORDER_DATA_2_STATISTICS='ORDER_DATA_2_STATISTICS';
export const ORDER_DATA_2_CREDIT='ORDER_DATA_2_CREDIT';
export const ORDER_DATA_2_REPAY='ORDER_DATA_2_REPAY';
export const ORDER_DATA_2_DETAIL='ORDER_DATA_2_DETAIL';